import { useMemo } from 'react'
import useBalance from '../contracts/hooks/token/useBalance'
import useTokenMetadata from './useTokenMetadata'
import { OwnedERC20 } from '../types/models/Tokens'

const useTokenForOwner = (
  owner: string | undefined,
  contractAddress: string | undefined
) => {
  const { data: token, isLoading: tokenMetadataLoading } =
    useTokenMetadata(contractAddress)

  const {
    balance,
    isLoading: balanceLoading,
    isRefetching: balanceRefetching,
    refetch: refetchBalance,
  } = useBalance({
    token: {
      contractAddress: contractAddress || '',
      decimals: token?.decimals,
      type: 'ERC20',
    },
    owner,
  })

  const tokenWithBalance = useMemo<OwnedERC20 | undefined | null>(() => {
    if (owner && token) {
      return { ...token, balance: balance || null } as OwnedERC20
    }
    return null
  }, [balance, owner, token])

  return {
    token: tokenWithBalance || null,
    loading: balanceLoading || tokenMetadataLoading || balanceRefetching,
    refetch: refetchBalance,
  }
}

export default useTokenForOwner
